import React, { useEffect, useState } from "react";
import img from "../../Images/Vouchers.png";
import appstore from "../../Images/Rectangle 55 (4).png";
import playstore from "../../Images/Rectangle 18.png";
import HomeService from "../../Services/HomeService";
const DownloadApp = () => {
  const [appPoster, setAppPoster] = useState({});

  const fetchAppPoster = async () => {
    try {
      const res = await HomeService?.getAppPoster();
      console.log("App Poster", res);
      if (res?.status) {
        setAppPoster(res?.data[0]);
      } else {
        console.log(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAppPoster();
  }, []);

  return (
    <>
      <div className="wall_of_fame_wrapper">
        <div className="search_cities_div download_app_wrapper">
          <div className="download_app_left">
            <h2>
              DOWNLOAD APP & <br />
              GET THE VOUCHER!
            </h2>
            <span>
              Get 30% off for first transaction using Rondovision mobile app for
              now.
            </span>
            <div
              onClick={() =>
                window.open(
                  "https://play.google.com/store/apps/details?id=com.winners.properties",
                  "_blank",
                  "noopener,noreferrer",
                )
              }
              className="play_store_wrapper"
            >
              <img src={appstore} />
              <img src={playstore} />
            </div>
          </div>
          <div className="app_screen_img_wrapper">
            <img className="app_screen_img" src={appPoster?.image} />
          </div>
        </div>
      </div>
    </>
  );
};

export default DownloadApp;
